export const heroData = {
  siteName: '91影视看片app',
  tagline: '每日更新 · 高清流畅',
  h1: '91影视看片app - 最新电影电视剧综艺一站畅享',
  slogan: '追剧看片，从这里开始',
  description: '91影视看片app每日更新最新电影在线看、热门电视剧全集和综艺节目在线播放资源。覆盖动作、悬疑、喜剧、爱情、科幻等全类型片库，无论你是喜欢追最新院线大片、重温经典老片，还是追看当下最火的国产剧、韩剧、美剧，这里都能满足你。影视排行榜实时更新，热门内容一网打尽，高清流畅不缓冲，追剧看片一站式搞定。',
  stats: [
    { label: '每日更新', value: '200+' },
    { label: '片源覆盖', value: '10万+' },
    { label: '高清画质', value: '1080P' },
  ],
  primaryCta: { text: '立即探索热门', href: '#ranking' },
  secondaryCta: { text: '下载 App', href: '#app' },
};

export const mediaCards = [
  {
    id: 1,
    title: '暑期档必看：2024年最值得期待的十部国产大片盘点',
    tag: '电影推荐',
    category: '观影指南',
    summary: '从动作巨制到温情喜剧，从科幻冒险到现实题材，这个暑期档的国产电影阵容堪称豪华。我们为你精选了十部不容错过的佳作。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20movie%20scene%20still%20with%20warm%20cinematic%20lighting%2C%20soft%20focus%20background%2C%20film%20grain%20texture%2C%20moody%20atmosphere%20with%20amber%20and%20coral%20tones%2C%20professional%20cinematography%20style%2C%2035mm%20film%20aesthetic%2C%20no%20visible%20faces%20or%20text&width=800&height=450&seq=media-card-01&orientation=landscape',
    duration: '8 分钟阅读',
    hot: true,
  },
  {
    id: 2,
    title: '高分韩剧《迷雾追踪》第二季回归，原班人马再掀悬疑热潮',
    tag: '热播剧集',
    category: '剧集速递',
    summary: '第一季豆瓣评分9.1的现象级悬疑韩剧正式回归。第二季延续烧脑剧情，新增重磅卡司加盟，首播即登顶收视冠军。',
    image: 'https://readdy.ai/api/search-image?query=Television%20series%20dramatic%20moment%20with%20rich%20warm%20tones%2C%20living%20room%20setting%20with%20subtle%20glow%20from%20screen%2C%20cinematic%20composition%2C%20cozy%20evening%20atmosphere%2C%20soft%20shadows%2C%20high%20production%20value%20still%20frame%2C%20no%20faces&width=800&height=450&seq=media-card-02&orientation=landscape',
    duration: '6 分钟阅读',
    hot: true,
  },
  {
    id: 3,
    title: '热门综艺《声生不息》新一季开播，全新赛制引发全网讨论',
    tag: '综艺热点',
    category: '综艺看点',
    summary: '顶级音乐综艺《声生不息》迎来全新赛季，升级赛制加入国际对战环节，首期节目话题阅读量突破5亿，引爆社交媒体。',
    image: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20setup%20with%20vibrant%20amber%20lighting%2C%20entertainment%20venue%20atmosphere%2C%20colorful%20set%20design%20with%20warm%20spotlights%2C%20professional%20broadcast%20production%20quality%2C%20dynamic%20composition%2C%20no%20faces&width=800&height=450&seq=media-card-03&orientation=landscape',
    duration: '5 分钟阅读',
    hot: false,
  },
];

export const aboutData = {
  title: '关于91影视',
  content: '91影视看片app是一个专注影视内容聚合与推荐的综合性平台，致力于为影迷剧迷提供最新电影在线看、热门电视剧全集追踪和综艺节目在线播放的一站式服务。我们每日更新片源，覆盖全球热门影视内容，从院线新片到经典老片，从国产热剧到海外佳作，影视排行榜实时更新，确保你不错过任何一部好作品。高清流畅的播放体验、简洁易用的界面设计，让追剧看片变得更加轻松愉快。',
  highlights: [
    { icon: 'ri-movie-2-line', label: '最新电影在线看', desc: '院线新片极速上线' },
    { icon: 'ri-tv-2-line', label: '热门电视剧全集', desc: '热播剧集每日更新' },
    { icon: 'ri-live-line', label: '综艺节目在线播放', desc: '热门综艺一网打尽' },
  ],
};

export const topicTags = [
  { id: 1, name: '暑期档电影', heat: '98.7万讨论', color: 'primary' },
  { id: 2, name: '悬疑剧推荐', heat: '86.3万讨论', color: 'accent' },
  { id: 3, name: '高分韩剧', heat: '75.2万讨论', color: 'secondary' },
  { id: 4, name: '国产动漫崛起', heat: '68.9万讨论', color: 'primary' },
  { id: 5, name: '综艺名场面', heat: '62.4万讨论', color: 'accent' },
  { id: 6, name: '科幻电影', heat: '55.8万讨论', color: 'secondary' },
  { id: 7, name: '古装剧造型', heat: '51.3万讨论', color: 'primary' },
  { id: 8, name: '美剧回归', heat: '47.6万讨论', color: 'accent' },
  { id: 9, name: '纪录片推荐', heat: '42.1万讨论', color: 'secondary' },
  { id: 10, name: '动画电影', heat: '38.5万讨论', color: 'primary' },
  { id: 11, name: '经典老片重温', heat: '35.2万讨论', color: 'accent' },
];

export const comments = [
  {
    id: 1,
    author: '影迷小白',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20style%20avatar%20silhouette%20with%20warm%20amber%20background%2C%20clean%20modern%20design%2C%20soft%20lighting&width=80&height=80&seq=avatar-01&orientation=squarish',
    content: '这个平台真的太棒了！每天都能看到最新的电影推荐，片源更新速度很快，画质也清晰。已经推荐给身边所有追剧的朋友了！',
    time: '2 小时前',
    likes: 238,
  },
  {
    id: 2,
    author: '追剧达人Leo',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20style%20avatar%20silhouette%20with%20coral%20warm%20background%2C%20clean%20modern%20design%2C%20soft%20lighting&width=80&height=80&seq=avatar-02&orientation=squarish',
    content: '影视排行榜功能特别好用，热播剧的排名一目了然，再也不用到处找推荐了。最近跟着榜单补了好几部之前错过的好剧。',
    time: '5 小时前',
    likes: 186,
  },
  {
    id: 3,
    author: '周末影咖',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20style%20avatar%20silhouette%20with%20warm%20gold%20background%2C%20clean%20modern%20design%2C%20soft%20lighting&width=80&height=80&seq=avatar-03&orientation=squarish',
    content: '综艺节目在线播放功能太方便了！周末窝在家里一口气追完了整季综艺，高清不卡顿，体验比很多付费平台还好。',
    time: '昨天',
    likes: 312,
  },
  {
    id: 4,
    author: '剧荒拯救者',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20style%20avatar%20silhouette%20with%20warm%20terracotta%20background%2C%20clean%20modern%20design%2C%20soft%20lighting&width=80&height=80&seq=avatar-04&orientation=squarish',
    content: '热门电视剧全集都有，终于不用等更新了！而且分类很清晰，悬疑剧、古装剧、现代剧一目了然，找剧超方便。',
    time: '昨天',
    likes: 156,
  },
  {
    id: 5,
    author: '深夜放映室',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20style%20avatar%20silhouette%20with%20warm%20cinnamon%20background%2C%20clean%20modern%20design%2C%20soft%20lighting&width=80&height=80&seq=avatar-05&orientation=squarish',
    content: '最新电影在线看的片源质量真的不错，1080P画质看起来就是爽。而且推荐算法很准，总能推到我感兴趣的内容。',
    time: '2 天前',
    likes: 421,
  },
];

export const updates = [
  {
    id: 1,
    date: '2024.08.01',
    title: '平台片源库突破10万+，覆盖全球30+国家地区影视内容',
    tag: '平台动态',
  },
  {
    id: 2,
    date: '2024.07.28',
    title: '暑期档专题页面上线，汇集50+部热门电影深度解析',
    tag: '新功能',
  },
  {
    id: 3,
    date: '2024.07.25',
    title: '影视排行榜算法升级，实时热度数据更新延迟降至5分钟',
    tag: '技术升级',
  },
  {
    id: 4,
    date: '2024.07.20',
    title: '新增「经典老片」专区，千部豆瓣8分以上佳作等你发现',
    tag: '内容更新',
  },
  {
    id: 5,
    date: '2024.07.15',
    title: '播放体验全面优化，高清画质下带宽消耗降低30%',
    tag: '体验优化',
  },
  {
    id: 6,
    date: '2024.07.10',
    title: '综艺节目在线播放频道扩展，新增日韩综艺专区',
    tag: '内容更新',
  },
  {
    id: 7,
    date: '2024.07.05',
    title: '用户反馈系统上线，你的每一条建议我们都会认真对待',
    tag: '社区建设',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '91影视看片app需要付费吗？',
    answer: '91影视看片app目前提供完全免费的影视内容浏览和推荐服务。你可以免费查看最新电影在线看资源、热门电视剧全集信息和综艺节目在线播放指南，无需任何付费即可享受全部功能。',
  },
  {
    id: 2,
    question: '平台上的影视资源画质如何？',
    answer: '我们平台推荐的影视资源普遍支持1080P高清画质，部分热门内容还提供4K超清版本。同时我们会对片源质量进行筛选，确保流畅不缓冲的观看体验。',
  },
  {
    id: 3,
    question: '影视排行榜的数据是如何更新的？',
    answer: '影视排行榜基于多维度的热度数据综合计算，包括全网讨论度、搜索指数、播放量趋势等，每5分钟自动刷新一次，确保榜单数据始终反映最新的热门内容动态。',
  },
  {
    id: 4,
    question: '如何找到自己想看的影视内容？',
    answer: '你可以通过首页的影视排行榜快速发现热门内容，也可以在主题索引中按分类浏览，或者使用搜索功能精准查找。我们还有基于你浏览习惯的个性化推荐，帮你发现更多好片。',
  },
  {
    id: 5,
    question: '支持哪些设备观看？',
    answer: '91影视看片app支持在手机、平板和电脑上使用。我们提供适配各种屏幕尺寸的界面，无论你使用iOS还是Android设备，都能获得流畅的使用体验。你也可以下载我们的App获得更好的移动端体验。',
  },
  {
    id: 6,
    question: '平台上的内容更新频率如何？',
    answer: '我们保持每日更新最新电影在线看和热门电视剧全集资源，综艺节目在线播放内容也会在播出后第一时间更新。平台团队全天候监控热门内容动态，确保你不会错过任何精彩。',
  },
];

export const rankingItems = [
  {
    id: 1,
    rank: 1,
    title: '迷雾追踪 第二季',
    type: '悬疑韩剧',
    score: 9.2,
    hot: '2.3万热度',
    trend: 'up',
  },
  {
    id: 2,
    rank: 2,
    title: '星际迷航：新纪元',
    type: '科幻电影',
    score: 8.8,
    hot: '1.9万热度',
    trend: 'up',
  },
  {
    id: 3,
    rank: 3,
    title: '声生不息 第三季',
    type: '音乐综艺',
    score: 9.0,
    hot: '1.7万热度',
    trend: 'new',
  },
  {
    id: 4,
    rank: 4,
    title: '长安十二时辰续',
    type: '古装剧集',
    score: 8.6,
    hot: '1.5万热度',
    trend: 'up',
  },
  {
    id: 5,
    rank: 5,
    title: '深海追凶',
    type: '犯罪电影',
    score: 8.4,
    hot: '1.3万热度',
    trend: 'stable',
  },
  {
    id: 6,
    rank: 6,
    title: '探秘敦煌',
    type: '纪录片',
    score: 8.9,
    hot: '1.1万热度',
    trend: 'new',
  },
];

export const carouselItems = [
  {
    id: 1,
    title: '暑期档观影指南：不可错过的十部佳片',
    tag: '编辑精选',
    summary: '从烧脑科幻到温情家庭片，这个夏天的大银幕精彩纷呈。我们为你准备了一份完整的观影清单，涵盖各类题材，总有一部适合你。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20strip%20abstract%20composition%20with%20warm%20amber%20and%20coral%20gradient%2C%20soft%20bokeh%20lights%2C%20movie%20theater%20atmosphere%2C%20artistic%20minimal%20design%2C%20dark%20background%20with%20glowing%20highlights%2C%20elegant%20cinematic%20aesthetic&width=1200&height=600&seq=carousel-01&orientation=landscape',
    color: 'from-amber-600/80 to-red-700/80',
  },
  {
    id: 2,
    title: '韩剧迷必追：2024下半年最受期待的十部剧',
    tag: '追剧日历',
    summary: '下半年韩剧市场火力全开，从浪漫爱情到硬核悬疑，从奇幻穿越到现实题材，十部重磅新剧蓄势待发，剧荒是不可能的。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20aesthetic%20with%20warm%20romantic%20lighting%2C%20soft%20focus%20cinematic%20style%2C%20evening%20cityscape%20background%20with%20bokeh%2C%20emotional%20atmosphere%2C%20film%20grain%20texture%2C%20high%20production%20value&width=1200&height=600&seq=carousel-02&orientation=landscape',
    color: 'from-rose-600/80 to-amber-600/80',
  },
  {
    id: 3,
    title: '综艺新势力：这些原创综艺正在改写行业规则',
    tag: '深度观察',
    summary: '从音乐竞演到生活纪实，一批原创综艺正在用全新的节目形态和内容理念赢得观众口碑。我们为你深度解析这些综艺的成功密码。',
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20stage%20with%20dramatic%20warm%20spotlights%2C%20colorful%20concert%20lighting%2C%20professional%20broadcast%20studio%20atmosphere%2C%20dynamic%20composition%2C%20vibrant%20amber%20and%20coral%20tones%2C%20high%20energy%20aesthetic&width=1200&height=600&seq=carousel-03&orientation=landscape',
    color: 'from-orange-600/80 to-amber-500/80',
  },
  {
    id: 4,
    title: '经典重温：那些年我们追过的国产神剧',
    tag: '怀旧特辑',
    summary: '有些电视剧无论过去多少年依然让人念念不忘。我们挑选了十部豆瓣评分9分以上的国产经典，带你回到那些守在电视机前的日子。',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20retro%20television%20aesthetic%2C%20warm%20vintage%20lighting%2C%20old%20TV%20set%20glow%20in%20cozy%20living%20room%2C%20soft%20grain%20texture%2C%20sentimental%20atmosphere%2C%20cinematic%20composition%2C%20amber%20tones&width=1200&height=600&seq=carousel-04&orientation=landscape',
    color: 'from-stone-700/80 to-amber-700/80',
  },
  {
    id: 5,
    title: '纪录片推荐：十部改变世界观的高分纪录片',
    tag: '知识充电',
    summary: '好的纪录片能打开一扇看世界的新窗口。从自然科学到人文历史，这十部高分纪录片每一部都值得你花时间认真观看和思考。',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20cinematic%20nature%20scene%20with%20warm%20golden%20hour%20lighting%2C%20epic%20landscape%20composition%2C%20soft%20atmospheric%20haze%2C%20professional%20film%20aesthetic%2C%20earth%20tones%20and%20amber%20highlights%2C%20serene%20mood&width=1200&height=600&seq=carousel-05&orientation=landscape',
    color: 'from-emerald-700/80 to-amber-600/80',
  },
];

export const featureCards = [
  {
    id: 1,
    icon: 'ri-speed-up-line',
    title: '最新电影在线看',
    desc: '院线新片极速上线，每日更新片源库，涵盖动作、悬疑、喜剧、科幻等全类型。1080P高清画质，告别模糊画质和卡顿体验。',
  },
  {
    id: 2,
    icon: 'ri-fire-line',
    title: '影视排行榜',
    desc: '实时更新的热门影视排行榜，综合全网讨论度与播放热度，帮你快速发现当下最受欢迎的电影、电视剧和综艺节目。',
  },
  {
    id: 3,
    icon: 'ri-stack-line',
    title: '热门电视剧全集',
    desc: '收录全网热播剧集，国产剧、韩剧、美剧、日剧全覆盖。追剧日历提醒，热门剧集更新不遗漏，全集资源一站聚合。',
  },
  {
    id: 4,
    icon: 'ri-live-line',
    title: '综艺节目在线播放',
    desc: '音乐、竞技、生活、旅行等各类综艺节目在线播放，热门综艺第一时间更新。从搞笑片段到精彩名场面，应有尽有。',
  },
];

export const appData = {
  title: '随时随地，追剧看片',
  subtitle: '下载91影视App，享受更流畅的移动观影体验',
  features: [
    '离线缓存，无网络也能看',
    '个性化推荐，越用越懂你',
    '夜间模式，熬夜追剧更护眼',
    '弹幕互动，边看边聊更精彩',
  ],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20movie%20streaming%20app%20interface%20with%20warm%20dark%20theme%2C%20film%20poster%20grid%20layout%2C%20modern%20mobile%20UI%20design%2C%20floating%20phone%20on%20subtle%20warm%20gradient%20background%2C%20clean%20minimal%20aesthetic&width=600&height=800&seq=app-mockup&orientation=portrait',
};

export const contactData = {
  title: '联系我们',
  subtitle: '有好的影视资源推荐？想和我们合作？欢迎随时联系',
  email: 'contact@91yingshi.app',
  socialLinks: [
    { name: '微博', icon: 'ri-weibo-line' },
    { name: '微信', icon: 'ri-wechat-line' },
    { name: '抖音', icon: 'ri-tiktok-line' },
  ],
};

export const indexItems = [
  { id: 1, title: '最新电影在线看', count: '2,356部', icon: 'ri-film-line', desc: '院线新片、经典老片、小众佳片' },
  { id: 2, title: '热门电视剧全集', count: '1,892部', icon: 'ri-tv-2-line', desc: '国产剧、韩剧、美剧、日剧' },
  { id: 3, title: '综艺节目在线播放', count: '987档', icon: 'ri-live-line', desc: '音乐、竞技、生活、旅行' },
  { id: 4, title: '悬疑推理剧场', count: '623部', icon: 'ri-search-eye-line', desc: '烧脑剧情、反转不断' },
  { id: 5, title: '科幻奇幻世界', count: '458部', icon: 'ri-rocket-line', desc: '星际探索、未来想象' },
  { id: 6, title: '动作冒险专区', count: '721部', icon: 'ri-flashlight-line', desc: '热血刺激、肾上腺素飙升' },
  { id: 7, title: '喜剧欢乐时光', count: '534部', icon: 'ri-emotion-happy-line', desc: '爆笑不断、解压必备' },
  { id: 8, title: '纪录片频道', count: '312部', icon: 'ri-earth-line', desc: '真实世界、深度纪录' },
];

export const cardItems = [
  {
    id: 1,
    title: '《深海追凶》——年度最佳犯罪悬疑片深度解读',
    tag: '影评',
    image: 'https://readdy.ai/api/search-image?query=Dark%20criminal%20investigation%20scene%20with%20dramatic%20warm%20lighting%2C%20noir%20atmosphere%2C%20mysterious%20mood%2C%20cinematic%20composition%20with%20amber%20highlights%2C%20film%20noir%20aesthetic%2C%20no%20visible%20faces&width=600&height=400&seq=card-01&orientation=landscape',
    summary: '层层递进的叙事结构令人窒息，三位主演的表演堪称教科书级别。导演用冷峻的镜头语言营造出令人不安的悬疑氛围。',
    author: '影评人李明',
    date: '2024.07.30',
  },
  {
    id: 2,
    title: '古装剧服化道大比拼：谁才是年度审美担当？',
    tag: '盘点',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20costume%20design%20with%20elegant%20silk%20fabric%2C%20warm%20golden%20lighting%2C%20historical%20drama%20aesthetic%2C%20intricate%20embroidery%20details%2C%20soft%20focus%20background%2C%20rich%20amber%20and%20coral%20tones&width=600&height=400&seq=card-02&orientation=landscape',
    summary: '从唐代宫廷到宋代市井，从明代武侠到清代宫廷，今年古装剧在服化道上的投入和用心程度令人惊叹。',
    author: '编辑小雨',
    date: '2024.07.28',
  },
  {
    id: 3,
    title: '韩剧迷的狂欢：下半年十部重磅新剧追剧日历',
    tag: '追剧',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20aesthetic%20with%20warm%20soft%20lighting%2C%20cozy%20cafe%20atmosphere%2C%20cinematic%20depth%20of%20field%2C%20emotional%20warm%20tones%2C%20high%20production%20value%20K-drama%20style&width=600&height=400&seq=card-03&orientation=landscape',
    summary: '整理了从8月到12月即将播出的十部最受期待的韩剧，每部都有详细看点分析，帮你提前锁定追剧目标。',
    author: '追剧达人Leo',
    date: '2024.07.26',
  },
  {
    id: 4,
    title: '国产动漫的黄金时代：这些国漫值得被更多人看到',
    tag: '国漫',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20style%20illustration%20with%20warm%20artistic%20lighting%2C%20ink%20wash%20painting%20aesthetic%2C%20fantasy%20elements%2C%20rich%20golden%20and%20coral%20tones%2C%20cinematic%20composition%2C%20elegant%20traditional%20meets%20modern&width=600&height=400&seq=card-04&orientation=landscape',
    summary: '从《哪吒》到《长安三万里》，国产动画电影正在经历前所未有的创作繁荣期。我们为你盘点那些被低估的国漫佳作。',
    author: '动漫观察员',
    date: '2024.07.24',
  },
  {
    id: 5,
    title: '综艺节目在线播放新趋势：小而美的原创综艺正在崛起',
    tag: '综艺',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20talk%20show%20studio%20set%20with%20warm%20intimate%20lighting%2C%20modern%20minimal%20design%2C%20comfortable%20seating%20arrangement%2C%20soft%20amber%20glow%2C%20professional%20broadcast%20quality%2C%20relaxed%20atmosphere&width=600&height=400&seq=card-05&orientation=landscape',
    summary: '在头部综艺争夺流量的同时，一批制作精良、选题独特的原创综艺正在用口碑赢得观众。小而美的综艺时代来了。',
    author: '综艺观察者',
    date: '2024.07.22',
  },
  {
    id: 6,
    title: '暑期带娃必看：适合全家一起欣赏的十部动画电影',
    tag: '亲子',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20film%20scene%20with%20warm%20cheerful%20lighting%2C%20family%20friendly%20atmosphere%2C%20bright%20amber%20and%20coral%20tones%2C%20cinematic%20quality%2C%20joyful%20composition%2C%20Pixar-style%20aesthetic&width=600&height=400&seq=card-06&orientation=landscape',
    summary: '暑期是带娃看电影的黄金时间。我们精选了十部既适合小朋友、又不会让大人无聊的优秀动画电影，附观影指南。',
    author: '亲子影评人',
    date: '2024.07.20',
  },
  {
    id: 7,
    title: '美剧秋季档前瞻：这些回归剧和新剧值得期待',
    tag: '美剧',
    image: 'https://readdy.ai/api/search-image?query=American%20TV%20series%20dramatic%20scene%20with%20warm%20cinematic%20lighting%2C%20urban%20night%20setting%2C%20professional%20production%20quality%2C%20amber%20and%20teal%20color%20palette%2C%20moody%20atmosphere%2C%20high-end%20TV%20drama%20aesthetic&width=600&height=400&seq=card-07&orientation=landscape',
    summary: '秋季档是美剧最重要的播出季之一。我们为你整理了今年秋季确定回归的经典剧集和值得关注的新剧，追剧日历收好。',
    author: '美剧迷小K',
    date: '2024.07.18',
  },
];

export const footerData = {
  siteName: '91影视看片app',
  description: '91影视看片app每日更新最新电影在线看、热门电视剧全集和综艺节目在线播放资源。影视排行榜实时更新，追剧看片一站式搞定，高清流畅不缓冲。',
  quickLinks: [
    { name: '最新电影在线看', href: '#media' },
    { name: '热门电视剧全集', href: '#ranking' },
    { name: '综艺节目在线播放', href: '#carousel' },
    { name: '影视排行榜', href: '#ranking' },
    { name: '主题索引', href: '#index' },
    { name: '常见问答', href: '#faq' },
  ],
};